import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { AsyncPipe, JsonPipe, NgOptimizedImage } from '@angular/common';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { MarkantElementsModule } from '@markant/elements-angular';
import { ActiveSectionState, GuidedTourService } from '../service/guided-tour.service';
import { Router } from '@angular/router';

@Component({
  selector: 'markant-platform-section-finish-dialog',
  standalone: true,
  templateUrl: './section-finish-dialog.component.html',
  styleUrls: ['./section-finish-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MarkantElementsModule, TranslocoModule, NgOptimizedImage, AsyncPipe, JsonPipe],
})
export class SectionFinishDialogComponent implements OnInit {
  @Input() sectionData!: ActiveSectionState;

  tourTitle = '';
  sectionTitle = '';
  showTourCompletedDialogContent = false;

  constructor(
    private translocoService: TranslocoService,
    private router: Router,
    private guidedTourService: GuidedTourService
  ) {}

  ngOnInit(): void {
    const sectionTitleTranslation = this.translocoService.translate(
      `guidedTour.tours.${this.sectionData.tourId}.section${this.sectionData.sectionNumber}.title`
    );
    const tourTitleTranslation = this.translocoService.translate(`guidedTour.tours.${this.sectionData.tourId}.title`);

    this.tourTitle = `<span class="text-highlight">«${tourTitleTranslation}»</span>`;
    this.sectionTitle = `<span class="text-highlight">«${sectionTitleTranslation}»</span>`;
  }

  async backToDashboard(): Promise<void> {
    await this.closeDialog();
    await this.router.navigate(['']);
  }

  async closeDialog(): Promise<void> {
    this.guidedTourService.closeEndDialog();
  }

  async nextSection(tourId: string, sectionNumber: number): Promise<void> {
    const hasCompleted = await this.guidedTourService.startNextOrComplete(tourId, sectionNumber);

    if (hasCompleted) {
      this.showTourCompletedDialogContent = true;
    }
  }

  async removeWidget(tourId: string): Promise<void> {
    this.guidedTourService.removeWidget(tourId);
    await this.backToDashboard();
  }

  async keepWidget(): Promise<void> {
    await this.backToDashboard();
  }
}
